import { Organization } from '@mp/kernel/organizations/domain';

import { ORGANIZATION_SEARCHABLE_IDENTIFIER_KEYS } from './organization-identifier-fields';

export function* filterOrganizationsBySearchTerm(
  organizations: Iterable<Organization>,
  searchTerm: string,
): Iterable<Organization> {
  if (!searchTerm) {
    yield* organizations;
    return;
  }

  searchTerm = searchTerm.toLowerCase();

  for (const o of organizations) {
    // Suche über Organisationsname und die durchsuchbaren Identifikationsfelder.
    const haystack = [o.name, ...ORGANIZATION_SEARCHABLE_IDENTIFIER_KEYS.map((key) => o[key])];
    const matches = haystack.some((value) => value?.toLowerCase().includes(searchTerm) === true);

    if (matches) {
      yield o;
    }
  }
}
